/* eslint-disable @typescript-eslint/no-unused-vars */
import { Key } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@mui/material";
import React, { useEffect, useState } from "react";
import mbaas from "../../provider/Mbaas";
import { requestKycUrl } from "../../provider/kycScripts";
// @ts-ignore
// @ts-ignore
import axios from "axios";
import createHash from "crypto-browserify";
import moment from "moment";
import {
  useNotify,
  useRefresh
} from "react-admin";
import { randomBytes, secretbox } from "tweetnacl";
import { ReactPanZoom } from "../RaPhotoPan";


const dummyimg = [
  "https://www.imigrasi.go.id/wp-content/uploads/2019/07/13-32-19-timthumb.jpeg",
  "https://cdn.dribbble.com/users/289900/screenshots/4610643/selfie1.jpg",
];
export default function FormKycDialogPassport({
  open,
  setOpen,
  data,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  data: any;
}) {
  const [token, setToken] = useState<string>("");
  const [remark, setRemark] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [imgzoom, setImgzoom] = useState<boolean>(false);
  const [imgblob, setImgblob] = useState("");
  const [idType, setIdType] = useState("passport-sip"); // passport-sip, passport, arc, hkid, armada
  const [idColumn, setIdColumn] = useState("document_id");
  const [idNumberColumn, setIdNumberColumn] = useState("passport_number");
  const [imgblobSelfie, setImgblobSelfie] = useState("");
  const [arcMode, setArcMode] = useState(false);

  const [imgblobdefault, setImgblobdefault] = useState("");
  const [imgblobSelfiedefault, setImgblobSelfiedefault] = useState("");
  // const [status, setStatus] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();

  // const registrasiData = data?.registrations_user_id_list?.data[0];
  const [passportData, setpassData] = useState(
    data?.passports_registration_id_list?.data[0]
  );

  useEffect(() => {
    directDecryptFile();
    directDecryptFileSelfie();
  }, [data]);

  useEffect(() => {
    setpassData(data?.passports_registration_id_list?.data[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const changeValue = (value: any, names: any) => {
    setpassData({
      ...passportData,
      [names]: value,
    });
  };

  // Backend schema requires these as string, but the DB column is nullable
  // and unused fields stay null depending on id_type (e.g. passport_number
  // for an HKID record), so coerce null to "" before submitting.
  const NULLABLE_STRING_FIELDS = [
    "document_id",
    "passport_number",
    "hk_id",
    "hkid_number",
    "arc_front",
    "arc_back",
    "arc_number",
  ];

  const sanitizePassportData = (pd: any) => {
    const sanitized = { ...pd };
    NULLABLE_STRING_FIELDS.forEach((field) => {
      if (sanitized[field] == null) {
        sanitized[field] = "";
      }
    });
    return sanitized;
  };

  // @ts-ignore
  const toBase64 = async (file, callback) => {
    const reader = new FileReader();

    let result = "";

    reader.readAsDataURL(file);
    reader.onload = async () => {
      // Use a regex to remove data url part

      // reader.result.replace("data:", "").replace(/^.+,/, "");
      // onB64Load(reader.result.replace("data:", "").replace(/^.+,/, ""), type);

      // if (type === "selfie") {
      // 	// @ts-ignore
      // 	setUSelfieB64(reader.result);
      // } else {
      // 	setUPassportB64(reader.result);
      // }

      // @ts-ignore
      result = reader.result;
      await callback(result);
      //   console.log(result, "KMZWA");
    };
  };

  const submitForm = async (e: any, status: boolean) => {
    try {
      const dataX = {
        token: token,
        data: {
          ...sanitizePassportData(passportData),
          remark: remark,
          status:
            e === "CANCELED" ? "CANCELED" : status ? "APPROVED" : "REJECTED",
        },
      };
      const req = await mbaas.client.invokeApi(
        "console-update-registration-account",
        dataX
      );
      console.log(req);

      if (req.error) {
        if (req.error.error) {
          notify(req.error.error, { type: "warning" });
        } else {
          notify("Please fill all input form", { type: "warning" });
        }
        return;
      }

      if (updateImage != null) {
        await toBase64(updateImage, async (b64: any) => {
          const secret = data.user_id_data.secret + data.user_id_data.id;
          const key = createHash.createHash("sha256").update(secret).digest();
          const nonce = randomBytes(secretbox.nonceLength);
          const binaryString = window.atob(b64?.split(",")[1]);
          const len = binaryString.length;
          const bytesImage = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytesImage[i] = binaryString.charCodeAt(i);
          }
          const ciphertext = secretbox(bytesImage, nonce, key);
          const mergedtext = new Uint8Array(nonce.length + ciphertext.length);
          mergedtext.set(nonce);
          mergedtext.set(ciphertext, nonce.length);
          // const uploadData = await mbaas.client.storage.upload({
          //   params: {
          //     filename:
          //       data?.passports_registration_id_list?.data[0]?.document_id,
          //     bucket: "registrations",
          //     expire: "20",
          //   },
          //   file: mergedtext,
          // });

          const resp = await requestKycUrl(passportData?.[idColumn]?.split("/")[1], "UPLOAD");

          if (resp) {
            await axios.request({
              method: "PUT",
              url: resp.data.url,
              data: updateImage,
            })
          }
        });

      }

      if (updateImageSelfie != null) {
        await toBase64(
          updateImageSelfie,
          async (selfieb64: any) => {
            const secret = data.user_id_data.secret + data.user_id_data.id;
            const key = createHash.createHash("sha256").update(secret).digest();
            const nonce = randomBytes(secretbox.nonceLength);
            const binaryString = window.atob(selfieb64?.split(",")[1]);
            const len = binaryString.length;
            const bytesImage = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
              bytesImage[i] = binaryString.charCodeAt(i);
            }
            const ciphertext = secretbox(bytesImage, nonce, key);
            const mergedtext = new Uint8Array(nonce.length + ciphertext.length);
            mergedtext.set(nonce);
            mergedtext.set(ciphertext, nonce.length);

            // await mbaas.client.storage.upload({
            //   params: {
            //     filename:
            //       data?.passports_registration_id_list?.data[0]?.selfie_id,
            //     bucket: "registrations",
            //     expire: "20",
            //   },
            //   file: mergedtext,
            // })

            const resp = await requestKycUrl(idType === 'armada' ? passportData.arc_back.split("/")[1] : passportData.selfie_id.split("/")[1], "UPLOAD");

            if (resp) {
              await axios({
                method: "PUT",
                url: resp.data.url,
                data: updateImageSelfie,
              })
            }
          }
        );
      }

      notify("Success update registration", { type: "success" });
      setRemark("");
      setToken("");

      setUpdateImage(null);
      setImgblob(imgblobdefault);
      // @ts-ignore
      hiddenFileInput.current.value = "";
      setUpdateImageSelfie(null);
      setImgblobSelfie(imgblobSelfiedefault);
      // @ts-ignore
      hiddenFileInputSelfie.current.value = "";
      setOpen(false);
      refresh();
    } catch (e) {
      console.log(e);
    }
  };

  const submitFormUpdate = async (e: any, status: string) => {
    try {
      const dataX = {
        token: token,
        data: {
          ...sanitizePassportData(passportData),
          remark: remark,
          status: e === "CANCELED" ? "CANCELED" : status,
        },
      };
      const req = await mbaas.client.invokeApi(
        "console-update-registration-account",
        dataX
      );
      console.log(req);

      if (req.error) {
        if (req.error.error) {
          notify(req.error.error, { type: "warning" });
        } else {
          notify("Please fill all input form", { type: "warning" });
        }
        return;
      }

      if (updateImage != null) {
        await toBase64(updateImage, async (b64: any) => {
          const secret = data.user_id_data.secret + data.user_id_data.id;
          const key = createHash.createHash("sha256").update(secret).digest();
          const nonce = randomBytes(secretbox.nonceLength);
          const binaryString = window.atob(b64?.split(",")[1]);
          const len = binaryString.length;
          const bytesImage = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytesImage[i] = binaryString.charCodeAt(i);
          }
          const ciphertext = secretbox(bytesImage, nonce, key);
          const mergedtext = new Uint8Array(nonce.length + ciphertext.length);
          mergedtext.set(nonce);
          mergedtext.set(ciphertext, nonce.length);
          // await mbaas.client.storage.upload({
          //   params: {
          //     filename:
          //       data?.passports_registration_id_list?.data[0]?.document_id,
          //     bucket: "registrations",
          //     expire: "20",
          //   },
          //   file: mergedtext,
          // })
          const resp = await requestKycUrl(passportData?.[idColumn]?.split("/")[1], "UPLOAD");

          if (resp) {
            await axios.request({
              method: "PUT",
              url: resp.data.url,
              data: updateImage,
            })
          }

        });

        // console.log(uploadData, 5758);
      }

      if (updateImageSelfie != null) {
        await toBase64(
          updateImageSelfie,
          async (selfieb64: any) => {
            const secret = data.user_id_data.secret + data.user_id_data.id;
            const key = createHash.createHash("sha256").update(secret).digest();
            const nonce = randomBytes(secretbox.nonceLength);
            const binaryString = window.atob(selfieb64?.split(",")[1]);
            const len = binaryString.length;
            const bytesImage = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
              bytesImage[i] = binaryString.charCodeAt(i);
            }
            const ciphertext = secretbox(bytesImage, nonce, key);
            const mergedtext = new Uint8Array(nonce.length + ciphertext.length);
            mergedtext.set(nonce);
            mergedtext.set(ciphertext, nonce.length);
            // const uploadData = await mbaas.client.storage.upload({
            //   params: {
            //     filename:
            //       data?.passports_registration_id_list?.data[0]?.selfie_id,
            //     bucket: "registrations",
            //     expire: "20",
            //   },
            //   file: mergedtext,
            // });
            const resp = await requestKycUrl(idType === 'armada' ? passportData.arc_back.split("/")[1] : passportData.selfie_id.split("/")[1], "UPLOAD");

            if (resp) {
              await axios.request({
                method: "PUT",
                url: resp.data.url,
                data: updateImageSelfie,
              })
            }
          }
        );

        // console.log(uploadData, 5758);
      }

      notify("Success update registration", { type: "success" });
      setRemark("");
      setToken("");

      setUpdateImage(null);
      setImgblob(imgblobdefault);
      // @ts-ignore
      hiddenFileInput.current.value = "";
      setUpdateImageSelfie(null);
      setImgblobSelfie(imgblobSelfiedefault);
      // @ts-ignore
      hiddenFileInputSelfie.current.value = "";
      setOpen(false);
      refresh();
    } catch (e) {
      console.log(e);
    }
  };

  const directDecryptFile = async () => {
    setLoading(true);
    try {
      const secretUser = data.user_id_data.secret;
      const idUser = data.user_id_data.id;

      const secret = secretUser + idUser;

      const key = createHash.createHash("sha256").update(secret).digest();
      let url = "";
      let idTypeValue = "passport-sip";

      if(data?.passports_registration_id_list?.data[0]?.id_type) {
        // M21 BUCKET (REGISTRATIONS)
        switch(data.passports_registration_id_list.data[0].id_type) {
          case "HKID":
            idTypeValue = "hkid";
            break;

          case "ARC":
            idTypeValue = "arc";
            break;

          case "PASSPORT":
            idTypeValue = "passport";
            break;
        }
      } else if (
        data?.passports_registration_id_list?.data[0]?.partner === "ARMADA"
      ) {
        // M21 BUCKET (PARTNERS)
        idTypeValue = "armada";
      } else if (
        data?.passports_registration_id_list?.data[0]?.document_id?.startsWith("passport-documents")
      ) {
        // M21 BUCKET (REGISTRATIONS) but encrypted
        idTypeValue = "passport";
      }
      // DEFAULT TO PASSPORT-SIP

      setIdType(idTypeValue);

      let idColumnName = 'document_id';
      let idNumberColumnName = 'passport_number';
      switch(idTypeValue) {
        case "hkid":
          idNumberColumnName = "hkid_number";
          idColumnName = "hk_id";
          break;
        case "arc":
        case "armada":
          idNumberColumnName = "arc_number";
          idColumnName = "arc_front";
          break;
      }
      setIdNumberColumn(idNumberColumnName);
      setIdColumn(idColumnName);

      // Some PASSPORT submissions have id_type set but the file was still
      // stored via the SIP upload mechanism (filename like "202606/..."),
      // not in the registrations bucket. The filename format is a more
      // reliable signal of where the file physically lives than id_type
      // alone, otherwise the registrations-bucket lookup 404s.
      if (
        idTypeValue === "passport" &&
        /^\d{6}\//.test(
          data?.passports_registration_id_list?.data[0]?.[idColumnName] || ""
        )
      ) {
        idTypeValue = "passport-sip";
      }

      let encrypted = false;
      if(idTypeValue === 'passport-sip') {
        const req = await requestKycUrl(data?.passports_registration_id_list?.data[0]?.[idColumnName], "DOWNLOAD");
        url = req.data.url;
      } else {
        encrypted = !data?.passports_registration_id_list?.data[0]?.id_type && idTypeValue === 'passport'
        const imgUrl = await mbaas.client.storage.downloadUrl({
          params: {
            bucket: idTypeValue === 'armada' ? "partners" : "registrations",
            expire: "20",
          },
          fileId: data?.passports_registration_id_list?.data[0]?.[idColumnName] ?? '',
        });
        url = imgUrl.data.url;
      }

      if(encrypted) {
        const { data: mergedtext } = await axios.request({
          method: "get",
          url,
          responseType: "arraybuffer",
        });
        const nonce = mergedtext.slice(0, secretbox.nonceLength);
        const ciphertext = mergedtext.slice(
          secretbox.nonceLength,
          mergedtext.length
        );

        const chpr = new Uint8Array(ciphertext);
        const iv = new Uint8Array(nonce);

        const plaintext = secretbox.open(chpr, iv, key);

        if (plaintext) {
          const blobUrl = await (window.URL ? URL : webkitURL).createObjectURL(
            new Blob([plaintext], { type: "image/*" })
          );
          // as blob
          setImgblob(blobUrl);
          setImgblobdefault(blobUrl);
          // as data
        } else {
          // Not all files on this path are secretbox-encrypted; some are
          // already plain images. Fall back to the raw bytes when decode
          // fails instead of erroring out and leaving the image blank.
          const blobUrl = await (window.URL ? URL : webkitURL).createObjectURL(
            new Blob([mergedtext], { type: "image/*" })
          );
          setImgblob(blobUrl);
          setImgblobdefault(blobUrl);
        }
      } else if (data?.passports_registration_id_list?.data[0]?.id_type || idTypeValue === 'passport-sip') {
        const { data: imageBuffer } = await axios.request({
          method: "GET",
          url,
          responseType: "arraybuffer",
        });
        const plaintext = secretbox.open(
          new Uint8Array(imageBuffer.slice(secretbox.nonceLength)),
          new Uint8Array(imageBuffer.slice(0, secretbox.nonceLength)),
          key
        );

        // Not all passport-sip files are secretbox-encrypted; some are
        // already plain images. Fall back to the raw bytes when decode fails
        // instead of erroring out and leaving the image blank.
        const blobUrl = await (window.URL ? URL : webkitURL).createObjectURL(
          plaintext
            ? new Blob([plaintext], { type: "image/*" })
            : new Blob([imageBuffer], { type: "image/*" })
        );
        setImgblob(blobUrl);
        setImgblobdefault(blobUrl);
      } else {
        setImgblob(url);
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  const directDecryptFileSelfie = async () => {
    setLoading(true);
    // setImgzoom(true);
    try {
      // console.log("====================================");
      // console.log(data);
      // console.log("====================================");
      const secretUser = data.user_id_data.secret;
      const idUser = data.user_id_data.id;

      const secret = secretUser + idUser;

      const key = createHash.createHash("sha256").update(secret).digest();
      let url = "";

      let encrypted = false;
      let idTypeValue = "passport-sip";

      if(data?.passports_registration_id_list?.data[0]?.id_type) {
        // M21 BUCKET (REGISTRATIONS)
        switch(data.passports_registration_id_list.data[0].id_type) {
          case "HKID":
            idTypeValue = "hkid";
            break;

          case "ARC":
            idTypeValue = "arc";
            break;

          case "PASSPORT":
            idTypeValue = "passport";
            break;
        }
      } else if (
        data?.passports_registration_id_list?.data[0]?.partner === "ARMADA"
      ) {
        // M21 BUCKET (PARTNERS)
        idTypeValue = "armada";
      } else if (
        data?.passports_registration_id_list?.data[0]?.selfie_id?.startsWith("passport-selfie")
      ) {
        // M21 BUCKET (REGISTRATIONS) but encrypted
        idTypeValue = "passport";
      }
      // Some PASSPORT submissions have id_type set but the file was still
      // stored via the SIP upload mechanism (filename like "202606/..."),
      // not in the registrations bucket. The filename format is a more
      // reliable signal of where the file physically lives than id_type
      // alone, otherwise the registrations-bucket lookup 404s.
      if (
        idTypeValue === "passport" &&
        /^\d{6}\//.test(
          data?.passports_registration_id_list?.data[0]?.selfie_id || ""
        )
      ) {
        idTypeValue = "passport-sip";
      }
      // DEFAULT TO PASSPORT-SIP

      setIdType(idTypeValue);

      if(idTypeValue === 'passport-sip') {
        const req = await requestKycUrl(data?.passports_registration_id_list?.data[0]?.selfie_id, "DOWNLOAD");
        url = req.data.url;
      } else {
        encrypted = !data?.passports_registration_id_list?.data[0]?.id_type && idTypeValue === 'passport'
        const imgUrl = await mbaas.client.storage.downloadUrl({
          params: {
            bucket: idTypeValue === 'armada' ? "partners" : "registrations",
            expire: "20",
          },
          fileId: idTypeValue === 'armada' ? data?.passports_registration_id_list?.data[0]?.arc_back : data?.passports_registration_id_list?.data[0]?.selfie_id,
        });
        url = imgUrl.data.url;
      }

      if(encrypted) {
        const { data: mergedtext } = await axios.request({
          method: "get",
          url,
          responseType: "arraybuffer",
        });
        const nonce = mergedtext.slice(0, secretbox.nonceLength);
        const ciphertext = mergedtext.slice(
          secretbox.nonceLength,
          mergedtext.length
        );

        const chpr = new Uint8Array(ciphertext);
        const iv = new Uint8Array(nonce);

        const plaintext = secretbox.open(chpr, iv, key);
        // const plaintext = secretbox.open(ciphertext, nonce, key);

        if (plaintext) {
          const blobUrl = await (window.URL ? URL : webkitURL).createObjectURL(
            new Blob([plaintext], { type: "image/*" })
          );

          // as blob
          setImgblobSelfie(blobUrl);
          setImgblobSelfiedefault(blobUrl);
        } else {
          // Not all files on this path are secretbox-encrypted; some are
          // already plain images. Fall back to the raw bytes when decode
          // fails instead of erroring out and leaving the image blank.
          const blobUrl = await (window.URL ? URL : webkitURL).createObjectURL(
            new Blob([mergedtext], { type: "image/*" })
          );
          setImgblobSelfie(blobUrl);
          setImgblobSelfiedefault(blobUrl);
        }
      } else if (data?.passports_registration_id_list?.data[0]?.id_type || idTypeValue === 'passport-sip') {
        const { data: imageBuffer } = await axios.request({
          method: "GET",
          url,
          responseType: "arraybuffer",
        });

        const plaintext = secretbox.open(
          new Uint8Array(imageBuffer.slice(secretbox.nonceLength)),
          new Uint8Array(imageBuffer.slice(0, secretbox.nonceLength)),
          key
        );

        // Not all passport-sip files are secretbox-encrypted; some are
        // already plain images. Fall back to the raw bytes when decode fails
        // instead of erroring out and leaving the image blank.
        const blobUrl = await (window.URL ? URL : webkitURL).createObjectURL(
          plaintext
            ? new Blob([plaintext], { type: "image/*" })
            : new Blob([imageBuffer], { type: "image/*" })
        );
        setImgblobSelfie(blobUrl);
        setImgblobSelfiedefault(blobUrl);
      } else {
        setImgblobSelfie(url);
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  const [updateImage, setUpdateImage] = useState(null);
  const [updateImageSelfie, setUpdateImageSelfie] =
    useState(null);

  const hiddenFileInput = React.useRef(null);
  const hiddenFileInputSelfie = React.useRef(null);

  const handleClick = (event: any) => {
    // @ts-ignore
    hiddenFileInput.current.click();
  };

  const handleClickSelfie = (event: any) => {
    // @ts-ignore
    hiddenFileInputSelfie.current.click();
  };

  const handleChange = (event: any) => {
    const fileUploaded = event.target.files[0];
    // console.log(fileUploaded, 666);
    setUpdateImage(fileUploaded);
    const extension = fileUploaded?.name?.split(".").pop() || "";
    const filename = `${moment().format("YYYYMM")}/passport_doc_${data.user_id}_${moment().format("YYYY-MM-DD-HH-mm-ss")}.${extension}`

    setpassData({
      ...passportData,
      [idColumn]: filename,
    });
    setImgblob(URL.createObjectURL(fileUploaded));
  };

  const handleChangeSelfie = (event: any) => {
    const fileUploaded = event.target.files[0];
    setUpdateImageSelfie(fileUploaded);
    const extension = fileUploaded?.name?.split(".").pop() || "";
    const filename = `${moment().format("YYYYMM")}/passport_sel_${data.user_id}_${moment().format("YYYY-MM-DD-HH-mm-ss")}.${extension}`

    setpassData({
      ...passportData,
      [idType === 'armada' ? "arc_back" : "selfie_id"]: filename,
    });
    setImgblobSelfie(URL.createObjectURL(fileUploaded));
  };

  return (
    <div>
      <Dialog
        open={imgzoom}
        aria-labelledby="form-dialog-title"
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle id="form-dialog-title">File Detail</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {loading ? (
              "LOADING . . ."
            ) : (
              <img
                src={imgblobSelfie}
                alt="imgpreview"
                style={{ width: 900 }}
              />
              // <FilerobotImageEditor
              // 	// @ts-ignore
              // 	show={false}
              // 	source={imgblob}
              // 	onClose={() => {}}
              // 	onBeforeSave={(_savedImageDataBefore) => false}
              // 	onSave={async (editedImageObject, _designState) => {
              // 		const secret = data?.user_id_data?.secret + data?.user_id_data?.id;
              // 		const key = createHash.createHash("sha256").update(secret).digest();
              // 		const nonce = randomBytes(secretbox.nonceLength);
              // 		const binaryString = window.atob(
              // 			editedImageObject.imageBase64?.split(",")[1] as string
              // 		);
              // 		const len = binaryString.length;
              // 		const bytesImage = new Uint8Array(len);
              // 		for (let i = 0; i < len; i++) {
              // 			bytesImage[i] = binaryString.charCodeAt(i);
              // 		}
              // 		const ciphertext = secretbox(bytesImage, nonce, key);
              // 		const mergedtext = new Uint8Array(nonce.length + ciphertext.length);
              // 		mergedtext.set(nonce);
              // 		mergedtext.set(ciphertext, nonce.length);
              // 		const uploadData = await mbaas.client.storage.upload({
              // 			params: {
              // 				filename: data?.passports_registration_id_list?.data[0]?.document_id,
              // 				bucket: "registrations",
              // 				expire: "20",
              // 			},
              // 			file: mergedtext,
              // 		});
              // 	}}
              // />
              // <img src={imgblob} alt="imgpreview" style={{ width: 900 }} />

              // <Zoom img={imgblob} zoomScale={2} width={900} height={500} />
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => setImgzoom(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        maxWidth="lg"
        fullWidth={true}
      >
        <DialogTitle id="form-dialog-title">
          <Grid container direction="row" alignItems="center" gap={1}>
            <Key /> Form KYC Account
          </Grid>
        </DialogTitle>
        {/* <form onSubmit={(e) => submitForm(e)}> */}
        <form onSubmit={(e) => e.preventDefault()}>
          <DialogContent>
            <DialogContentText>
              {passportData?.country_code !== "IDN" && (
                <Grid container xs={12} style={{ marginBlockEnd: "10px" }}>
                  <Grid item xs={12}>
                    <Alert severity="error">
                      <AlertTitle>
                        The current user is <strong>NOT eligible</strong> to
                        have a Virtual Number (VN). Please check the{" "}
                        <strong>KYC Data!</strong>
                      </AlertTitle>
                    </Alert>
                  </Grid>
                </Grid>
              )}
              <Grid container spacing={2}>
                <Grid
                  item
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                  xs={6}
                > 
                  <div style={{ marginInlineEnd: 10 }}>{idType === 'armada' ? 'ARC FRONT' : 'ID Image'}</div>
                  <>
                    <Button
                      style={{ width: "auto", textTransform: "none", display: idType === 'armada' ? 'none' : 'block' }}
                      variant="contained"
                      onClick={handleClick}
                    >
                      Update Image
                    </Button>
                    <input
                      type="file"
                      ref={hiddenFileInput}
                      onChange={handleChange}
                      style={{ display: "none" }}
                    />
                  </>
                  {updateImage && (
                    <Button
                      style={{
                        width: "auto",
                        textTransform: "none",
                        marginInlineStart: 10,
                      }}
                      variant="outlined"
                      onClick={() => {
                        setUpdateImage(null);
                        setImgblob(imgblobdefault);
                        // @ts-ignore
                        hiddenFileInput.current.value = "";
                      }}
                    >
                      Reset Image
                    </Button>
                  )}
                </Grid>
                <Grid item xs={6}>
                  Data checking for pending subscriber registration
                </Grid>
              </Grid>
            </DialogContentText>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBlockStart: 10,
                  }}
                >
                  {loading ? (
                    "LOADING . . ."
                  ) : (
                    // <img src={imgblob} alt="imgpreview" style={{ width: 500 }} />
                    <div
                      style={{
                        width: 600,
                        maxWidth: 600,
                        maxHeight: 300,
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <ReactPanZoom image={imgblob} alt="imgpreview" />
                    </div>
                    // <Zoom img={imgblob} zoomScale={2} width={900} height={500} />
                  )}
                </div>
                <DialogContentText style={{ marginBlockStart: 20 }}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                      xs={12}
                    >
                      <div style={{ marginInlineEnd: 10 }}>
                        {idType === 'armada' ? 'ARC BACK' : 'Selfie Image'}
                      </div>
                      <>
                        <Button
                          style={{ width: "auto", textTransform: "none", display: idType === 'armada' ? 'none' : 'block' }}
                          variant="contained"
                          onClick={handleClickSelfie}
                        >
                          Update Selfie Image
                        </Button>
                        <input
                          type="file"
                          ref={hiddenFileInputSelfie}
                          onChange={handleChangeSelfie}
                          style={{ display: "none" }}
                        />
                      </>
                      {updateImageSelfie && (
                        <Button
                          style={{
                            width: "auto",
                            textTransform: "none",
                            marginInlineStart: 10,
                          }}
                          variant="outlined"
                          onClick={() => {
                            setUpdateImageSelfie(null);
                            setImgblobSelfie(imgblobSelfiedefault);
                            // @ts-ignore
                            hiddenFileInputSelfie.current.value = "";
                          }}
                        >
                          Reset Image
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </DialogContentText>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBlockStart: 10,
                  }}
                >
                  {loading ? (
                    "LOADING . . ."
                  ) : (
                    // <img src={imgblob} alt="imgpreview" style={{ width: 500 }} />
                    <div
                      style={{
                        width: 600,
                        maxWidth: 600,
                        maxHeight: 300,
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <ReactPanZoom image={imgblobSelfie} alt="imgpreview" />
                    </div>
                    // <Zoom img={imgblob} zoomScale={2} width={900} height={500} />
                  )}
                </div>
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{ display: "flex", flexDirection: "row", width: "100%" }}
                >
                  <TextField
                    label="Country code"
                    value={passportData?.country_code || ""}
                    onChange={(e) =>
                      changeValue(e.target.value, "country_code")
                    }
                    required
                    fullWidth
                  />
                </Box>
                <Box
                  sx={{ display: "flex", flexDirection: "row", width: "100%" }}
                >
                  <TextField
                    label={
                      idType === "hkid"
                        ? "HKID number"
                        : idType === "arc" || idType === "armada"
                        ? "ARC number"
                        : "Passport number"
                    }
                    value={passportData?.[idNumberColumn] || ""}
                    onChange={(e) =>
                      changeValue(e.target.value, idNumberColumn)
                    }
                    required
                    fullWidth
                  />
                </Box>
                <Box
                  sx={{ display: "flex", flexDirection: "row", width: "100%" }}
                >
                  <TextField
                    label="Fullname"
                    value={passportData?.full_name || ""}
                    onChange={(e) => changeValue(e.target.value, "full_name")}
                    required
                    fullWidth
                  />
                  <Box width={"32px"} />
                  <FormControl variant="filled" sx={{ minWidth: 120 }} fullWidth>
                    <InputLabel id="demo-simple-select-filled-label">
                      Gender
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-filled-label"
                      id="demo-simple-select-filled"
                      value={passportData?.gender || "L"}
                      onChange={(e) => changeValue(e.target.value, "gender")}
                      fullWidth
                    >
                      <MenuItem value={"P"}>Perempuan</MenuItem>
                      <MenuItem value={"L"}>Laki Laki</MenuItem>
                    </Select>
                  </FormControl>
                  {/* <TextField
										label="Citizenship"
										value={passportData?.citizenship || ""}
										onChange={(e) => changeValue(e.target.value, "citizenship")}
										required
										fullWidth
									/> */}
                </Box>
                <Box
                  sx={{ display: "flex", flexDirection: "row", width: "100%" }}
                >
                  <TextField
                    label="Citizenship"
                    value={passportData?.citizenship || ""}
                    onChange={(e) => changeValue(e.target.value, "citizenship")}
                    required
                    fullWidth
                  />
                </Box>
                <Box
                  sx={{ display: "flex", flexDirection: "row", width: "100%" }}
                >
                  <TextField
                    id="date"
                    label="Date of birth"
                    type="date"
                    value={passportData?.birthdate || ""}
                    onChange={(e) => changeValue(e.target.value, "birthdate")}
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <Box width={"32px"} />
                  <TextField
                    label="Place of birth"
                    value={passportData?.place_of_birth || ""}
                    onChange={(e) => changeValue(e.target.value, "place_of_birth")}
                    required
                    fullWidth
                  />
                </Box>
                <Box
                  sx={{ display: "flex", flexDirection: "row", width: "100%" }}
                >
                  <TextField
                    id="date"
                    label="Date of expiry"
                    type="date"
                    fullWidth
                    value={passportData?.date_of_expiry || ""}
                    onChange={(e) =>
                      changeValue(e.target.value, "date_of_expiry")
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                {/* <Box
									style={{ marginBlockStart: 10, marginBlockEnd: 20 }}
									sx={{
										display: "flex",
										justifyContent: "space-between",
										flexDirection: "row",
										width: "100%",
									}}
								>
									<>
										<Button
											style={{ width: "100%", textTransform: "none" }}
											variant="contained"
											onClick={handleClick}
										>
											Update Passport Image
										</Button>
										<input
											type="file"
											ref={hiddenFileInput}
											onChange={handleChange}
											style={{ display: "none" }}
										/>
									</>

									<Box width={"32px"} />
									<>
										<Button
											style={{ width: "100%", textTransform: "none" }}
											variant="contained"
											onClick={handleClickSelfie}
										>
											Update Passport Selfie Image
										</Button>
										<input
											type="file"
											ref={hiddenFileInputSelfie}
											onChange={handleChangeSelfie}
											style={{ display: "none" }}
										/>
									</>
								</Box> */}
                <Box
                  sx={{ display: "flex", flexDirection: "row", width: "100%" }}
                >
                  {/* <TextField
										label="Registration Number"
										value={passportData?.registration_number || ""}
										onChange={(e) =>
										changeValue(e.target.value, "registration_number")
										}
										required
										fullWidth
									/> */}
                  <Box width={"32px"} />
                </Box>
                <Box
                  sx={{ display: "flex", flexDirection: "row", width: "100%" }}
                >
                  {/* <TextField
										label="Issuing Office"
										value={passportData?.issuing_office || ""}
										onChange={(e) => changeValue(e.target.value, "issuing_office")}
										required
										fullWidth
									/> */}
                  <TextField
                    label="Remark (Note)"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    required
                    fullWidth
                  />
                  <Box width={"32px"} />

                  <TextField
                    label="Token"
                    value={token}
                    required
                    fullWidth
                    onChange={(e) => setToken(e.target.value)}
                  />
                </Box>
              </Grid>
            </Grid>

            {/* <div style={{ margin: "20px 0px 10px 0px" }}>Registration File</div> */}
            <Grid container direction="row" alignItems="center" gap={1}>
              {/* <Button
								size="small"
								variant="contained"
								onClick={() => decryptFile(passportData?.document_id)}
								disabled={
									passportData?.document_id === null ||
									passportData?.document_id === undefined
								}
							>
								Document
							</Button> */}
              {/* <Button
								size="small"
								variant="contained"
								onClick={() => decryptFile(passportData?.selfie_id)}
								disabled={
									passportData?.selfie_id === null ||
									passportData?.selfie_id === undefined
								}
							>
								Selfie
							</Button> */}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid container direction="row" justifyContent="space-between">
              <Button
                onClick={() => {
                  setUpdateImage(null);
                  setImgblob(imgblobdefault);
                  // @ts-ignore
                  hiddenFileInput.current.value = "";
                  setUpdateImageSelfie(null);
                  setImgblobSelfie(imgblobSelfiedefault);
                  // @ts-ignore
                  hiddenFileInputSelfie.current.value = "";
                  setOpen(false);
                }}
                // disabled={loading}
                color="primary"
                size="small"
              >
                Close
              </Button>
              {data?.status === "PENDING" ? (
                <Grid item gap={2}>
                  <Button
                    style={{ marginRight: "20px", backgroundColor: "#e02828" }}
                    color="secondary"
                    variant="contained"
                    size="small"
                    type="submit"
                    startIcon={<CancelIcon />}
                    onClick={(e) => submitForm(e, false)}
                  >
                    REJECT
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    type="submit"
                    startIcon={<CheckCircleIcon />}
                    onClick={(e) => submitForm(e, true)}
                  >
                    ACCEPT
                  </Button>
                </Grid>
              ) : data?.status === "APPROVED" ? (
                <Grid item gap={2}>
                  <Button
                    style={{ marginRight: "20px", backgroundColor: "#e02828" }}
                    color="secondary"
                    variant="contained"
                    size="small"
                    type="submit"
                    startIcon={<CancelIcon />}
                    onClick={(e) => submitForm("CANCELED", false)}
                  >
                    CANCEL REGISTRATION
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    type="submit"
                    startIcon={<CheckCircleIcon />}
                    onClick={(e) => {
                      submitFormUpdate(e, data?.status);
                    }}
                  >
                    UPDATE DATA
                  </Button>
                </Grid>
              ) : (
                <Grid item gap={2}>
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    type="submit"
                    startIcon={<CheckCircleIcon />}
                    onClick={(e) => {
                      submitFormUpdate(e, data?.status);
                    }}
                  >
                    UPDATE DATA
                  </Button>
                </Grid>
              )}
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
